import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#4db050;}" }) }), /* @__PURE__ */ _jsx("path", {
		className: "cls-1",
		d: "M0,10.08,4.84,5.24,9.48,9.88,19.36,0,24,4.64,9.68,19S-.13,10.21,0,10.08Z"
	})]
});
export default SvgComplete;
